import debug from 'debug';
import React, { PropsWithChildren } from 'react';
import {
  ErrorBoundaryState,
  ErrorBoundaryProps,
  ErrorBoundaryErrorInfo
} from './types';

export const DefaultErrorView: React.FC<ErrorBoundaryState> = () => (
  <h1>Something went wrong.</h1>
);

export class ErrorBoundary extends React.Component<
  PropsWithChildren<ErrorBoundaryProps>,
  ErrorBoundaryState
> {
  public constructor(props: ErrorBoundaryProps) {
    super(props);

    this.state = {
      error: undefined
    };
  }

  public static getDerivedStateFromError(error: Error) {
    return { error };
  }

  public componentDidCatch(error: Error, info: ErrorBoundaryErrorInfo) {
    debug.log(info.componentStack);
    debug.log('componentDidCatch');
    debug.log(error);
    this.setState({
      error
    });
    // TODO: Log error to third party service.
  }

  public render() {
    const { error } = this.state;
    const { children, component } = this.props;
    if (error) {
      if (component) {
        return React.createElement(component, { error });
      }
      return <DefaultErrorView error={error} />;
    }
    return children;
  }
}
